import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MaterialsSection from "@/components/MaterialsSection";
import InspirationSection from "@/components/InspirationSection";
import Calculator from "@/pages/Calculator";
import ContactSection from "@/components/ContactSection";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const PrintDetails = () => {
  return (
    <div className="min-h-screen bg-[#f5f5f7]">
      <Navbar />

      {/* Page Header */}
      <header className="bg-[#1d1d1f] pt-32 pb-20">
        <div className="max-w-6xl mx-auto px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/40 text-[13px] hover:text-white/70 transition-colors mb-8"
          >
            <ArrowLeft className="w-3.5 h-3.5" /> Startseite
          </Link>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-[13px] font-medium text-white/40 uppercase tracking-widest mb-3">
              Details
            </p>
            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-5">
              3D-Druck
            </h1>
            <p className="text-[17px] text-white/55 max-w-xl leading-relaxed">
              Materialien, Kostenrechner und Anwendungsbeispiele.
              Alles, was für eine Anfrage gebraucht wird.
            </p>
          </motion.div>
        </div>
      </header>

      {/* Tabs: Materialien / Kostenrechner / Anwendungen */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <Tabs defaultValue="materials" className="w-full">
            <TabsList className="bg-[#f5f5f7] border border-black/5 p-1 rounded-full inline-flex gap-1 mb-12">
              <TabsTrigger
                value="materials"
                className="data-[state=active]:bg-white data-[state=active]:text-[#1d1d1f] data-[state=active]:shadow-sm rounded-full px-5 py-2 text-[13px] font-medium text-[#1d1d1f]/50 transition-all"
              >
                Materialien
              </TabsTrigger>
              <TabsTrigger
                value="calculator"
                className="data-[state=active]:bg-white data-[state=active]:text-[#1d1d1f] data-[state=active]:shadow-sm rounded-full px-5 py-2 text-[13px] font-medium text-[#1d1d1f]/50 transition-all"
              >
                Kostenrechner
              </TabsTrigger>
              <TabsTrigger
                value="inspiration"
                className="data-[state=active]:bg-white data-[state=active]:text-[#1d1d1f] data-[state=active]:shadow-sm rounded-full px-5 py-2 text-[13px] font-medium text-[#1d1d1f]/50 transition-all"
              >
                Anwendungen
              </TabsTrigger>
            </TabsList>

            <TabsContent value="materials">
              <Alert className="mb-10 bg-[#f5f5f7] border-black/10 text-[#6e6e73]">
                <InfoIcon className="h-4 w-4 text-[#1d1d1f]/40" />
                <AlertDescription className="text-[13px]">
                  Nicht vorrätige Filamente können auf Anfrage bestellt werden.
                </AlertDescription>
              </Alert>
              <MaterialsSection />
            </TabsContent>

            <TabsContent value="calculator">
              <Alert className="mb-10 bg-[#f5f5f7] border-black/10 text-[#6e6e73]">
                <InfoIcon className="h-4 w-4 text-[#1d1d1f]/40" />
                <AlertDescription className="text-[13px]">
                  Beta: Die berechneten Preise sind Richtwerte. Für ein genaues Angebot einfach anfragen.
                </AlertDescription>
              </Alert>
              <Calculator />
            </TabsContent>

            <TabsContent value="inspiration">
              <InspirationSection />
            </TabsContent>
          </Tabs>
        </div>
      </section>

      <section id="kontakt">
        <ContactSection />
      </section>

      <Footer />
    </div>
  );
};

export default PrintDetails;
